import window from "common/objects/window";

export default class Help {
    constructor(helpPages) {
        this._helpPages = helpPages;
    }

    open(pageKey) {
        // open a new tab/window for help
        window.open(this.getLink(pageKey), "_blank");
    }

    /**
     * Get content associated with this key.
     * @param key
     * @returns {*}
     */
    getExcerpt(key) {
        if (key && this._helpPages[key]) {
            return this._helpPages[key].content;
        } else {
            return "";
        }
    }

    /**
     * Get the URL this key points to.
     * @param key
     * @returns {string}
     */
    getLink(key) {
        var page = this.getPage(key);
        return context.path + "/documentation/" + page;
    }

    getPage(key) {
        if (key && this._helpPages[key]) {
            return this._helpPages[key].page;
        } else {
            return "";
        }
    }
}
